import LegalContracts from "../../../../src/pages/use-cases/page-content/agreements-and-contracts/legal-contracts.md";
import * as React from 'react';
export default {
  LegalContracts,
  React
};